import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que dejar de darle el pecho de noche?',
    a: 'No, este método respeta la lactancia, solo separa el acto de comer del acto de dormir.'
  }, {
    q: '¿Funciona con bebés temperamentales?',
    a: 'Sí, al ser gradual, se adapta perfectamente a bebés que necesitan más contacto.'
  }, {
    q: '¿Es un libro físico?',
    a: 'Es un producto digital de descarga inmediata para que empieces hoy mismo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-13">
      <div className="max-w-3xl mx-auto px-6" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6" data-id="element-16">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-px bg-amber mx-auto" data-id="element-17"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-navy/10 rounded-2xl overflow-hidden bg-cream" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-20">
                <span className="font-serif text-lg text-navy font-medium pr-4" data-id="element-21">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-amber transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
              </button>

              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-24">
                    <div className="px-6 pb-5 text-navy/70 leading-relaxed" data-id="element-25">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}